import { Stack } from "@mui/material";
import { PrimaryButton, SecondaryButton } from "../../../components/common";
import { useContractContext } from "../../../contexts/ContractContext";
import { useOrganizationContext } from "../../../contexts/OrganizationContext";
import dayjs from "dayjs";
import {
  getNextPaymentDueDate,
  isFluxPayContract as isFluxPayContractUtil,
  isFreePlanContract,
} from "@/utils/contract";

export function SubmitActions({
  goBack,
  goForward,
  loading,
  buttonText = "Avançar",
  disableSubmit = false,
}: any) {
  const { currentContract } = useContractContext();
  const { typeOrganization } = useOrganizationContext();
  const contract = currentContract?.[0]?.resource;

  // Verifica se o contrato é do tipo fluxPay
  const isFluxPayContract = isFluxPayContractUtil(contract);

  // Busca a extensão subscriptionType se existir
  const subscriptionTypeExtension =
    contract?.extension?.find((el: any) =>
      el?.url.includes("subscriptionType")
    )?.valueString;

  // Verifica se é um contrato de período grátis:
  // Tipo "bus" E subscriptionType contém "Profissional autônomo - Período grátis"
  const isFreeTrialContract =
    typeOrganization === "bus" &&
    subscriptionTypeExtension?.includes(
      "Profissional autônomo - Período grátis"
    );

  // Plano gratuito: não deve bloquear ações por ausência de `nextPaymentDueDate`.
  const isFreePlan = isFreePlanContract(contract);

  // Verifica se há a extensão nextPaymentDueDate no contrato (contratos pagos)
  const nextPaymentDueDateExtension = getNextPaymentDueDate(contract);

  // Para período grátis: calcula se está dentro dos 30 dias
  const contractIssuedDate = dayjs(
    contract?.term?.[0]?.issued
  );
  const daysSinceIssued =
    isFreeTrialContract && contractIssuedDate.isValid()
      ? dayjs().diff(contractIssuedDate, "day")
      : null;
  const isWithinFreeTrialPeriod =
    isFreeTrialContract && daysSinceIssued !== null && daysSinceIssued < 30;

  // Verifica se é tipo "bus" e não possui extensão nextPaymentDueDate
  // Com fluxPay, mesmo sem nextPaymentDate está ativo, então não desabilita o botão
  // Período grátis dentro dos 30 dias também não desabilita o botão
  const isBusWithoutNextPayment =
    typeOrganization === "bus" &&
    !nextPaymentDueDateExtension &&
    !isFluxPayContract &&
    !isFreePlan &&
    !isWithinFreeTrialPeriod;

  return (
    <Stack
      width="100%"
      direction={!goBack ? "row-reverse" : "row"}
      justifyContent="space-between"
    >
      {goBack && (
        <SecondaryButton width="180px" height="50px" onClick={goBack}>
          Voltar
        </SecondaryButton>
      )}

      <PrimaryButton
        width="180px"
        height="50px"
        loading={loading}
        onClick={goForward}
        // Sem contrato ativo: trata como plano gratuito e não bloqueia por isso.
        disabled={disableSubmit || isBusWithoutNextPayment}
      >
        {buttonText}
      </PrimaryButton>
    </Stack>
  );
}
